import SearchableSelect from './SearchableSelect';
import { recruiterDisplayLabel, recruiterSearchText } from './entitySearchLabels';

export default function SearchableRecruiterSelect({
  recruiters = [],
  value,
  onChange,
  placeholder = 'Search by name, email, phone, or ID…',
  allowEmpty = false,
  emptyLabel = 'Unassigned',
  compact = false,
  showHint = true,
  loading = false,
  className = ''
}) {
  return (
    <SearchableSelect
      items={recruiters}
      value={value}
      onChange={onChange}
      getValue={r => r.id}
      getLabel={recruiterDisplayLabel}
      getSearchText={recruiterSearchText}
      placeholder={placeholder}
      hint="Search by name, email, or phone"
      showHint={showHint && !compact}
      allowEmpty={allowEmpty}
      emptyLabel={emptyLabel}
      compact={compact}
      loading={loading}
      className={className}
      clearAriaLabel="Clear recruiter"
    />
  );
}
